import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import type { ReactNode } from "react";

import { SearchIcon } from "../../../../../assets/icons";
import { ActionButton, DetailsActions } from "../../../components/global";

type Props = {
  title: ReactNode;
  isSavingDocument: boolean;
  onOpenFindBar: () => void;
  onSaveDocument: () => void;
  onPrint: () => void;
};

const DoctrineDetailsHeaderActions = ({
  title,
  isSavingDocument,
  onOpenFindBar,
  onSaveDocument,
  onPrint,
}: Props) => {
  const renderActions = ({ hideLabelOnMobile = false } = {}) => (
    <>
      <ActionButton
        icon={<SearchIcon />}
        label="Buscar"
        hideLabelOnMobile={hideLabelOnMobile}
        onClick={onOpenFindBar}
        title="Abrir busca customizada (Ctrl+F)"
      />
      <ActionButton
        icon={<BookmarkBorderOutlinedIcon fontSize="small" />}
        onClick={onSaveDocument}
        disabled={isSavingDocument}
        label={isSavingDocument ? "Salvando..." : "Salvar"}
        hideLabelOnMobile={hideLabelOnMobile}
      />
      <ActionButton
        icon={<PrintOutlinedIcon fontSize="small" />}
        label="Imprimir"
        hideLabelOnMobile={hideLabelOnMobile}
        onClick={onPrint}
      />
    </>
  );

  return (
    <DetailsActions
      title={title}
      renderActions={renderActions}
      wrapStickyWithContainer={false}
    />
  );
};

export default DoctrineDetailsHeaderActions;
